import { Component, inject, input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { RdsDividerModule, RdsIconsModule} from '@rds/angular-components';
import { SafeHtmlPipe } from '../../../pipes/safe-html.pipe';

@Component({
  selector: 'inexp-knowledge-best-practices',
  imports: [RdsIconsModule, SafeHtmlPipe, RdsDividerModule],
  templateUrl: './knowledge-best-practices.component.html',
  styleUrl: './knowledge-best-practices.component.scss',
  encapsulation: ViewEncapsulation.None // <-- Add this line
})
export class KnowledgeBestPracticesComponent {
  _uid = input<string>();
  component = input<string>();
  knowledgeSection = input<string>();
  router = inject(Router);
  bestPractices = input<any[]>();
  hasPublishedItems(): boolean {
    return this.bestPractices()?.some(b => b.published === true) ?? false;
  }
}
